import React from 'react';
import { Edit, Trash2, Pin, PinOff, Clock, User } from 'lucide-react';
import { caseNotesService } from '../../services/api';

const NoteCard = ({ note, onEdit, onDelete, onTogglePin }) => {
  const noteTypeIcon = caseNotesService.getNoteTypeIcon(note.note_type);
  const noteTypeLabel = caseNotesService.getNoteTypeLabel(note.note_type);
  const eventDateTime = caseNotesService.formatEventDateTime(note.event_date, note.event_time);

  const authorName = note.user
    ? `${note.user.first_name} ${note.user.last_name}`
    : 'Unknown';

  const createdAt = new Date(note.created_at).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });

  return (
    <div
      className={`border rounded-lg p-4 hover:shadow-md transition-shadow ${
        note.is_pinned ? 'border-yellow-300 bg-yellow-50' : 'border-gray-200 bg-white'
      }`}
    >
      {/* Header */}
      <div className="flex items-start justify-between mb-2">
        <div className="flex items-center space-x-2">
          <span className="text-lg" title={noteTypeLabel}>
            {noteTypeIcon}
          </span>
          <span className="text-sm font-medium text-gray-600">{noteTypeLabel}</span>
          {note.is_pinned && (
            <span className="text-xs bg-yellow-200 text-yellow-800 px-2 py-0.5 rounded-full flex items-center">
              <Pin className="h-3 w-3 mr-1" />
              Pinned
            </span>
          )}
        </div>
        <div className="flex items-center space-x-1">
          <button
            onClick={() => onTogglePin(note)}
            className="p-1 text-gray-400 hover:text-yellow-600 rounded transition-colors"
            title={note.is_pinned ? 'Unpin note' : 'Pin note'}
          >
            {note.is_pinned ? (
              <PinOff className="h-4 w-4" />
            ) : (
              <Pin className="h-4 w-4" />
            )}
          </button>
          <button
            onClick={() => onEdit(note)}
            className="p-1 text-gray-400 hover:text-gray-700 rounded transition-colors"
            title="Edit note"
          >
            <Edit className="h-4 w-4" />
          </button>
          <button
            onClick={() => onDelete(note)}
            className="p-1 text-gray-400 hover:text-red-600 rounded transition-colors"
            title="Delete note"
          >
            <Trash2 className="h-4 w-4" />
          </button>
        </div>
      </div>

      {/* Title */}
      {note.title && (
        <h4 className="font-semibold text-gray-900 mb-1">{note.title}</h4>
      )}

      {/* Content */}
      <p className="text-gray-700 whitespace-pre-wrap mb-3">{note.content}</p>

      {/* Footer */}
      <div className="flex items-center justify-between text-xs text-gray-500 pt-2 border-t border-gray-100">
        <div className="flex items-center space-x-3">
          <span className="flex items-center" title="Event date/time">
            <Clock className="h-3 w-3 mr-1" />
            {eventDateTime}
          </span>
        </div>
        <div className="flex items-center" title={`Logged ${createdAt}`}>
          <User className="h-3 w-3 mr-1" />
          {authorName}
        </div>
      </div>
    </div>
  );
};

export default NoteCard;
